import React from "react";
import TranscribeComponent from "../components/TranscribeComponent";

const Transcribe = () => {
    return <TranscribeComponent />;
}

export default Transcribe;